import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form, InputNumber, Spin, Select, Upload, Modal, Tabs, Space, DatePicker, Checkbox } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, UploadOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, DownloadOutlined, PlusOutlined, StopOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import PropTypes from 'prop-types';//props传参检查库
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message';
import UploadModal from './uploadModal';
import './student.css'
import StudentProgFormModal from './studentProgFormModal';
import SelectProgModal from '../../component/selectProgModal/selectProgModal';
import BatchInactiveModal from './batchInactiveModal';

const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;
const { confirm } = Modal;

const student = (props) => {

    const [form2] = Form.useForm();
    const messageRef = useRef();
    const [form] = Form.useForm();
    const imageNum = 1;
    const activeInd = Form.useWatch('activeInd', form);
    const [tabIndex, setTabIndex] = useState("1");
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [isInactiveFrame, setIsInactiveFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [studentModel, setStudentModel] = useState({});
    const [studentProgModel, setStudentProgModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [inactiveTipText, setInactiveTipText] = useState("");
    const [inactiveContent, setInactiveContent] = useState("");
    const [studentProgList, setStudentProgList] = useState([]);
    const [isUpload, setIsUpload] = useState(false);
    const [isBatchInactive, setIsBatchInactive] = useState(false);
    const [isStudentProgForm, setIsStudentProgForm] = useState(false);
    const [deleteFlag, setDeleteFlag] = useState("");
    const [cohortProgList, setCohortProgList] = useState([]);
    const [studentProgFormFlag, setStudentProgFormFlag] = useState('add');
    const [showCurrentCohort, setShowCurrentCohort] = useState(true)
    const [cohortList, setCohortList] = useState([]);
    const [deptList, setDeptList] = useState([]);
    const [nowCohort, setNowCohort] = useState({});
    const [imageFile, setImageFile] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [isSearchProgModal, setIsSearchProgModal] = useState(false);
    const [searchProgModel, setSearchProgModel] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);

    const disabledDate = current => {
        return current && current > moment().endOf('day');
    };

    const tableColumns = {
        studentAcctId: "student_acct_id",
        inactiveDate: "inactive_date",
        cohortYear: 'cohoet_year',
        studentEntryYear: 'student_entry_year',
    }

    useEffect(() => {
        searchCohortProgList();
        searchCohortList()
        searchAllDept();
        search(pageSize, 1, "N")
    }, []);

    //查询
    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("commonDropDown/searchAllDept").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortProg/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
                let newModel = { cohortId: Config?.cohort?.cohortId };
                // setSearchModel(newModel);
                // form2.setFieldsValue(newModel)
                setNowCohort(newModel);
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const searchCohortProgList = () => {
        Base.callBackApi("commonDropDown/searchCohortProgList").then((data) => {
            if ("SUCCESS" === data.msg) {
                Config.cohortProgList = (data?.object ?? []);
            }
        }).catch(err => { });
    }

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        model.cohortYear = Config.cohort?.cohortYear
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("student/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        // setSearchModel(nowCohort);
        // form2.setFieldsValue(nowCohort)
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setShowCurrentCohort(true)
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    //添加
    const add = () => {
        messageShowHandler();//清空提示信息
        setStudentModel({})
        setStudentProgList([])
        setImageFile([]);
        initForm({ activeInd: 'Y' });
        setFlag("add");
        setTabIndex("2");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            studentAcctId: model.studentAcctId ?? '',
            firstName: model.firstName ?? '',
            lastName: model.lastName ?? '',
            email: model.email ?? '',
            activeInd: model.activeInd ?? '',
            inactiveDate: (model.inactiveDate && moment(model.inactiveDate)) ?? null,
            contactPhone: model.contactPhone ?? '',
            whatsApp: model.whatsApp ?? '',
            weChat: model.weChat ?? '',
            linkedIn: model.linkedIn ?? '',
            personalWeb: model.personalWeb ?? '',
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const inactiveFrameClose = (state) => {
        if (state) {
            selectInactive();
        }
        setIsInactiveFrame(false);
    }

    const deleteOne = (model, e, type) => {
        e.stopPropagation();
        setStudentModel(model)
        setDeleteFlag('')
        setIsDeleteFrame(true);
        setDeleteTipText("Student ID:" + model.studentAcctId + ",Student Name:" + model.studentName)
    }

    //删除
    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        if (deleteFlag === 'studentProg') {
            let model = studentProgModel;
            model.menuFuncId = Config.funcInfo.funcId;
            Base.callBackApi("studentProgramme/delete", model).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchStudentProgList(studentModel.userId, showCurrentCohort);
                    errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(
                () => {
                    setIsLoad(false)
                    setDeleteFlag('')
                }
            );
        } else {
            let model = studentModel;
            model.menuFuncId = Config.funcInfo.funcId;
            Base.callBackApi("student/delete", model).then((data) => {
                if ("SUCCESS" === data.msg) {
                    setSearchModel({});
                    search(pageSize, current, "Y", false);
                    errFrameShow("success", trans.deleteSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    const onSave = (model) => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        if (imageFile && imageFile.length > 0) {
            model.studentPhotoModel = {
                status: imageFile[0].imgStatus,
                url: imageFile[0].originUrl,
            };
        }
        let url = "";
        if (flag === "add") {
            url = "student/insert";
        } else if (flag === "edit") {
            url = "student/update";
            model.studentId = studentModel.studentId;
            model.userId = studentModel.userId;
            model.lastUpdatedDate = studentModel.lastUpdatedDate;
        }
        if (model.activeInd === 'Y') {
            model.inactiveDate = null
        }
        if(!model.email) {
            model.email = model.studentAcctId + '@stu.thei.edu.hk';
        }
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" == data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const download = () => {
        setIsUpload(true)
    }

    const batchInactive = () => {
        setIsBatchInactive(true)
    }

    const uploadClose = (flag) => {
        if (flag) {
            search(pageSize, 1, "N");
            errFrameShow("success", trans.importSuccess[Config.backLang]);
        }
        setIsUpload(false);
    }

    const batchInactiveClose = (flag) => {
        if (flag) {
            search(pageSize, 1, "N");
            errFrameShow("success", trans.importSuccess[Config.backLang]);
        }
        setIsBatchInactive(false);
    }

    //取消 
    const cancel = () => {
        messageShowHandler();
        setShowCurrentCohort(true)
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const update = (model, e) => {
        messageShowHandler()
        e.stopPropagation();
        setShowCurrentCohort(true)
        searchById(model.studentId)
        // searchStudentProgList(model)
        setTabIndex("2");
    }

    const searchById = (studentId) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("student/searchById", studentId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                let file = [];
                if (model.studentPhoto) {
                    file.push({
                        url: Config.studentPhotoImg + model.studentPhoto + '?' + Config.sasToken,
                        originUrl: model.studentPhoto,
                        imgStatus: "OLD"
                    })
                }
                setImageFile(file);
                setFlag("edit");
                initForm(model)
                setStudentModel(model)
                searchStudentProgList(model.userId, showCurrentCohort);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const studentProgAdd = () => {
        messageShowHandler();
        if (Base.isEmpty(studentModel.studentId)) {
            errFrameShow("error", trans.saveStudent[Config.backLang]);
            return;
        }
        setStudentProgModel({});
        setStudentProgFormFlag('add')
        setIsStudentProgForm(true);
    }

    const closeStudentProgForm = (flag) => {
        if (flag) {
            errFrameShow("success", trans.saveSuccess[Config.backLang]);
            searchStudentProgList(studentModel.userId, showCurrentCohort);
        }
        setIsStudentProgForm(false);
    }


    const changeShowCurrentCohort = (event) => {
        setShowCurrentCohort(event.target.checked);
        searchStudentProgList(studentModel.userId, event.target.checked)
    };

    /**查询Student的StudentProglist */
    const searchStudentProgList = (userId, showCurrentCohortFlag) => {
        let model = {
            userId: userId,
            cohortId: showCurrentCohortFlag ? (Config?.cohort?.cohortId ?? '') : '',
            current: showCurrentCohortFlag ? 'current' : '',
        }
        Base.callBackApi("studentProgramme/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setStudentProgList(data.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => { });
    }

    const studentProgEdit = (model, e) => {
        messageShowHandler();
        setStudentProgFormFlag('edit')
        setStudentProgModel(model);
        setIsStudentProgForm(true);
    }

    const studentProgDelete = (model, e) => {
        e.stopPropagation();
        setStudentProgModel(model);
        setDeleteFlag('studentProg')
        setDeleteTipText("Programme Code" + ":" + model.progCode + "")
        setIsDeleteFrame(true);
    }

    const onSearch = () => {
        search(pageSize, 1, "N")
    }

    /**关闭图片弹窗 */
    const handleCancel = () => {
        setPreviewVisible(false);
    }

    /**查看图片 */
    const handlePreview = (file) => {
        setPreviewImage(file.url || file.thumbUrl);
        setPreviewVisible(true);
    }

    const handleRemove = (file) => {
        confirm({
            content: trans.deleteImg[Config.backLang],
            okText: trans.ok[Config.backLang],
            okType: 'danger',
            cancelText: trans.cancel[Config.backLang],
            onOk() {
                let index = imageFile.findIndex(item => item.uid == file.uid);
                let fileList = JSON.parse(JSON.stringify(imageFile));
                fileList.splice(index, 1);
                setImageFile(fileList);
            },
            onCancel() {
            },
        });
        return false;
    }

    /**图片改变事件 */
    const handleChange = (file) => {
        let fileList = file.fileList;
        file = file.file;
        if (file.status === "removed") {
            let index = imageFile.findIndex(item => item.uid == file.uid);
            let fileList = JSON.parse(JSON.stringify(imageFile));
            fileList.splice(index, 1)
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(file.originFileObj);
            reader.onload = (e) => {
                fileList[fileList.length - 1].originUrl = e.target.result;
                fileList[fileList.length - 1].imgStatus = "NEW";
            }
        }
        setImageFile(fileList);
    }

    const checkImg = (value) => {
        if (!!imageFile && imageFile.length > 0 && !!value) {
            let list = value.fileList;
            if (list.find(item => item.status === "uploading")) {
                return Promise.reject(trans.awaitImg[Config.backLang]);
            }
            if (list.find(item => item.status === "error")) {
                return Promise.reject(trans.loseImg[Config.backLang]);
            }
        }
        return Promise.resolve();
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>{trans.settingsImg[Config.backLang]}</div>
        </div>
    );

    const closeSearchProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, } };
            });
            setSearchProgModel(cohortProg);
        }
        setIsSearchProgModal(false);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: trans.studentAcctId[Config.backLang],
            dataIndex: 'studentAcctId',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: trans.studentName[Config.backLang],
            dataIndex: 'firstName',
            className: 'tableWidth10',
            render: (text, record) => text + ' ' + record.lastName
        },
        {
            title: trans.email[Config.backLang],
            dataIndex: 'email',
            className: 'tableWidth6',
        },
        // {
        //     title: trans.cohortYear[Config.backLang],
        //     dataIndex: 'cohortYear',
        //     className: 'tableWidth10',
        //     sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortYear') },
        // },
        {
            title: trans.studentEntryYear[Config.backLang],
            dataIndex: 'studentEntryYear',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentEntryYear') },
        },
        {
            title: 'Department',
            dataIndex: 'deptCode',
            className: 'tableWidth10',
        },
        {
            title: 'Programme Code',
            dataIndex: 'progCode',
            className: 'tableWidth13',
        },
        {
            title: 'Programme Name',
            dataIndex: 'progTitle',
            className: 'tableWidth13',
        },
        {
            title: 'Study Year Entry',
            dataIndex: 'studyYearEntry',
            className: "tableWidth12",
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'activeInd',
            className: 'tableWidth6',
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
        {
            title: trans.inactiveDate[Config.backLang],
            dataIndex: 'inactiveDate',
            className: 'tableWidth11',
            render: text => text ? moment(text).format(Config.dateFormat5) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed: 'right',
            className: ' sysControls',
            // width: 228,
            width: 130,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                {/* <div className='sysDelete' onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div> */}
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    const studentProgColumns = [
        {
            title: trans.cohortYear[Config.backLang],
            dataIndex: 'cohortYear',
            className: "tableWidth14",
        },
        {
            title: trans.deptCode[Config.backLang],
            dataIndex: 'deptCode',
            className: "tableWidth20",
        },
        {
            title: trans.progCode[Config.backLang],
            dataIndex: 'progCode',
            className: "tableWidth20",
        },
        {
            title: trans.progTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: "tableWidth20",
        },
        {
            title: trans.studentEntryYear[Config.backLang],
            dataIndex: 'studentEntryYear',
            className: "tableWidth11",
        },
        {
            title: 'Study Year Entry',
            dataIndex: 'studyYearEntry',
            className: "tableWidth15",
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            width: 228,
            className: ' sysControls',
            fixed: 'right',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => studentProgEdit(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => studentProgDelete(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ]
    /*eslint-enable*/

    const downloadTemplate = () => {
        setIsLoad(true);
        setSpinInfo(trans.loading[Config.backLang]);
        fetch(Config.apiDownloadServer + "studentTemplate/exportTemplate", {
            method: 'POST',
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "StudentTemplate.xlsx";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    }
        
    const studentInactive = (e) => {
        e.stopPropagation();
        messageShowHandler()
        if (checkboxState == null || checkboxState.length == 0) {
            errFrameShow("error", trans.leastOneDate[Config.backLang]);
            return;
        }
        setInactiveContent('Are you sure to inactive ?')
        setIsInactiveFrame(true);
    }

    const selectInactive = () => {
        let inactiveList = checkboxState.filter(item => item.activeInd === 'N')
        if (inactiveList.length > 0) {
            let msg = inactiveList.map(item => item.studentAcctId).join(', ');
            errFrameShow("error", 'The Student ID (' + msg + ') is inactive and cannot be inactive again.');
            return;
        }
        let model = {
            studentModelList: checkboxState
        }
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("student/selectInactive", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                search(pageSize, 1, "N");
                setCheckboxState([])
                setSelectedRowKeys([])
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    return (
        <div id="container" className="template student">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.admin[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isInactiveFrame ? <PopupFrame close={inactiveFrameClose} deleteTipText={inactiveTipText} content={inactiveContent} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <Form form={form2} onFinish={onSearch}>
                                <div className='sysSearchRow sysSearchBox'>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.studentAcctId[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Input type="text" value={searchModel.studentAcctId || ''}
                                                    placeholder={trans.studentAcctId[Config.backLang]}
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('studentAcctId', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.studentName[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Input type="text" value={searchModel.studentName || ''}
                                                    placeholder={trans.studentName[Config.backLang]}
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('studentName', e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.activeInd[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Select className="sysSelect" placeholder={trans.activeInd[Config.backLang]}
                                                    value={searchModel.activeInd || ''}
                                                    onChange={(e) => searchChange('activeInd', e)}
                                                >
                                                    <Option value=""></Option>
                                                    {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </div>
                                        </div>
                                        {/* <div className='sysCol'>
                                            <div className="sysTitle ">{trans.cohortYear[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]}
                                                    value={searchModel.cohortId || ''}
                                                    onChange={(e) => searchChange('cohortId', e)}
                                                >
                                                    <Option value=''></Option>
                                                    {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                                </Select>
                                            </div>
                                        </div> */}
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.studentEntryYear[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Input type="text" value={searchModel.studentEntryYear || ''}
                                                    placeholder={trans.studentEntryYear[Config.backLang]}
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('studentEntryYear', e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.deptCode[Config.backLang]}</div>
                                            <div className="sysSerchInput">
                                                <Select className="sysSelect" placeholder={trans.deptCode[Config.backLang]}
                                                    value={searchModel.deptId || ''}
                                                    onChange={(e) => searchChange('deptId', e)}
                                                >
                                                    <Option value=""></Option>
                                                    {deptList.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + '-' + item.deptDisplayName}</Option>)}
                                                </Select>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">{trans.progCode[Config.backLang]}</div>
                                            <div className="sysButtonSearchInput">
                                                <Input type="text" value={searchModel.progCode || ''} disabled
                                                    placeholder={trans.progCode[Config.backLang]}
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('progCode', e.target.value)} />
                                            </div>
                                            <Button className="sysBtn btnBlue" onClick={() => { setIsSearchProgModal(true) }}>Select</Button>
                                            {searchModel.progName && <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>}
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysTitle">Study Year Entry</div>
                                            <div className="sysSerchInput">
                                                <Input type="text" value={searchModel.studyYearEntry || ''}
                                                    placeholder='Study Year Entry'
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('studyYearEntry', e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='sysSearchButton'>
                                            <Button className="sysBtn btnBlue" type="primary" onClick={() => form2.submit()} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button className="sysBtn btnBlue" type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                <Button className='sysBtn btnBlue' type="primary" onClick={downloadTemplate} hidden={Config.funcInfo.canUpload === "N"} icon={<DownloadOutlined />}>{trans.downloadTemplate[Config.backLang]}</Button>
                                <Button type="primary" className="sysBtn btnBlue" onClick={() => download()} hidden={Config.funcInfo.canUpload === "N"} icon={<UploadOutlined />}>{trans.batchUpload[Config.backLang]}</Button>
                                <Button type="primary" className="sysBtn btnBlue" onClick={() => batchInactive()} hidden={Config.funcInfo.canUpload === "N"} icon={<UploadOutlined />}>{trans.batchInactive[Config.backLang]}</Button>
                                <Button type="primary" className="sysBtn btnBlue" onClick={(e) => studentInactive(e)} hidden={Config.funcInfo.canUpdate === "N"} icon={<StopOutlined />}>{trans.inactive[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowSelection}
                                    scroll={{ x: 1600 }}
                                    rowKey="studentId"
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]} forceRender={true}>
                            <Form
                                form={form} onFinish={onSave}
                            >
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.studentAcctId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="studentAcctId"
                                                rules={[
                                                    { required: true, message: trans.studentAcctIdIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.studentAcctId[Config.backLang]} maxLength={50}
                                                    disabled={flag === 'edit'}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {activeInd === 'Y' ?
                                        <div className='sysCol'>
                                            <div className="sysParam ">{trans.email[Config.backLang]} </div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="email"
                                                    rules={[
                                                        // { required: true, message: trans.emailIsNoNull[Config.backLang] },
                                                        { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: trans.incorrectEmailFormat[Config.backLang] },
                                                    ]}
                                                >
                                                    <Input type="text"
                                                        placeholder={trans.email[Config.backLang]}
                                                        maxLength={50}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        :
                                        <div className='sysCol'>
                                            <div className="sysParam">{trans.email[Config.backLang]} </div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="email"
                                                >
                                                    <Input type="text"
                                                        placeholder={trans.email[Config.backLang]}
                                                        maxLength={50}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.firstName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="firstName"
                                                rules={[
                                                    { required: true, message: trans.firstNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.firstName[Config.backLang]} maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.lastName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="lastName"
                                                rules={[
                                                    { required: true, message: trans.lastNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.lastName[Config.backLang]} maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.activeInd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="activeInd"
                                                rules={[
                                                    { required: true, message: trans.activeIndIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select placeholder={trans.activeInd[Config.backLang]} className='sysSelect'
                                                    onChange={(e) => {
                                                        if (e === 'N') {
                                                            form.setFieldValue('inactiveDate', moment())
                                                        } else {
                                                            form.setFieldValue('inactiveDate')
                                                        }
                                                    }}
                                                >
                                                    <Option value=""></Option>
                                                    {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {activeInd === 'N' ?
                                        <div className='sysCol'>
                                            <div className="sysParam mustFill">{trans.inactiveDate[Config.backLang]} </div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                    rules={[
                                                        { required: true, message: 'Inactive Date is required.' },
                                                    ]}
                                                >
                                                    <DatePicker placeholder={trans.inactiveDate[Config.backLang]}
                                                        className="parts-numberInput datePickerAllWidth"
                                                        disabledDate={disabledDate}
                                                        format={Config.dateFormat5} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        :
                                        <div className='sysCol'>
                                            <div className="sysParam ">{trans.inactiveDate[Config.backLang]} </div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                >
                                                    <DatePicker placeholder={trans.inactiveDate[Config.backLang]}
                                                        className="parts-numberInput datePickerAllWidth"
                                                        disabled
                                                        format={Config.dateFormat5} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Contact Phone</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="contactPhone"
                                                getValueFromEvent={(e) => e.target.value.replace(/\D/g, '')}
                                            >
                                                <Input type="text"
                                                    placeholder='Contact Phone' maxLength={12}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">WhatsApp</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="whatsApp"
                                            >
                                                <Input type="text"
                                                    placeholder='WhatsApp' maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">WeChat</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="weChat"
                                            >
                                                <Input type="text"
                                                    placeholder='WeChat' maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">LinkedIn</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="linkedIn"
                                            >
                                                <Input type="text"
                                                    placeholder='LinkedIn' maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Personal Web</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="personalWeb"
                                            >
                                                <Input type="text"
                                                    placeholder='Personal Web' maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.img[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Modal title={trans.maxImg[Config.backLang]} visible={previewVisible} footer={null} onCancel={handleCancel}>
                                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                            </Modal>
                                            <Form.Item
                                                name="img"
                                                rules={[
                                                    { validator: (rule, value) => checkImg(value) }
                                                ]}
                                            >
                                                <ImgCrop rotationSlider aspect={1 / 1} modalTitle="Edit Picture">

                                                    <Upload
                                                        action={Config.uploadTestServer}
                                                        key={"1"}
                                                        accept=".png, .jpg, .jpeg"
                                                        listType="picture-card"
                                                        fileList={imageFile}
                                                        onPreview={handlePreview}
                                                        onRemove={handleRemove}
                                                        onChange={(file) => handleChange(file)}>
                                                        {imageFile.length >= imageNum ? null : uploadButton}
                                                    </Upload>
                                                </ImgCrop>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                            <div className="sysBodyRow">
                                <div className="userRoleTitleRow">{trans.studentProg[Config.backLang]}</div>
                                <div className="sysBodyRow">
                                    <Button className="sysBtnTwo btnBlue" type="primary" hidden={Config.funcInfo.canInsert === "N"} onClick={studentProgAdd} icon={<PlusCircleOutlined />} >{trans.add[Config.backLang]}</Button>
                                    <Checkbox checked={showCurrentCohort} onChange={changeShowCurrentCohort}>Show Current Cohort</Checkbox>
                                </div>
                            </div>
                            <div className="sysTable" id="tableTwo">
                                <Table
                                    scroll={{ x: 1300 }}
                                    rowKey="studentProgId" //Key值
                                    columns={studentProgColumns} //列名
                                    dataSource={studentProgList} //数据
                                    pagination={false}
                                />
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isUpload && <UploadModal onClose={uploadClose} />}
            {isBatchInactive && <BatchInactiveModal onClose={batchInactiveClose} />}
            {/* 用户的角色添加编辑弹框 */}
            {isStudentProgForm && <StudentProgFormModal onClose={closeStudentProgForm} studentModel={studentModel} studentProgModel={studentProgModel} studentProgFormFlag={studentProgFormFlag} />}
            {isSearchProgModal && <SelectProgModal onClose={closeSearchProgModal} progModel={searchProgModel} />}
        </div>
    )
}

export default student;